import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from '@reach/router';

import LegalDocument from '../../components/LegalDocument';

function TermsEs() {
  return (
    <LegalDocument title="Términos de Servicio del Personal">
      <Helmet>
        <meta
          name="description"
          content="FECHA DE VIGENCIA: 1° de junio de 2018"
        />
        <meta
          itemprop="description"
          content="FECHA DE VIGENCIA: 1° de junio de 2018"
        />
        <meta
          property="og:description"
          content="FECHA DE VIGENCIA: 1° de junio de 2018"
        />
      </Helmet>
      <p>FECHA DE VIGENCIA: 1° de septiembre de 2023</p>
      <h4>Gracias por elegir Spur.</h4>
      <p>
        Estos términos y condiciones, junto con nuestra Política de privacidad
        disponible en <Link to="/privacy-policy">“Política de privacidad”</Link>
        , y todas las leyes y condiciones o políticas aplicables a las que se
        hace referencia en el presente documento y que se incorporan aquí por
        referencia (colectivamente los “Términos de Servicio”) rigen el uso de
        este sitio web (
        <a href="https://spurstaffing.com/">www.spurstaffing.com;</a>) o de
        nuestras aplicaciones móviles (en cualquier caso, el “Sitio”). Al
        utilizar el Sitio, acepta los Términos de Servicio en su totalidad. Si
        no está de acuerdo con alguna parte de los Términos de Servicio, no debe
        usar el Sitio. Usted debe ser competente para celebrar un contrato bajo
        la ley de su estado de residencia para utilizar el Sitio. Al usar el
        Sitio y al aceptar los Términos de Servicio, usted garantiza y declara
        que ha alcanzado la mayoría de edad y que es competente para celebrar un
        contrato bajo las leyes federales, estatales y locales correspondientes.
        Al acceder, registrarse o utilizar el Sitio de cualquier manera,
        incluyendo, pero no limitado a, visitar o navegar por el Sitio o
        contribuir con contenido, información u otros materiales o servicios al
        Sitio, usted acepta estar sujeto a los Términos de Servicio. Su uso de
        este Sitio debe estar en estricto cumplimiento con estos Términos de
        Servicio y de conformidad con todas las leyes y regulaciones locales,
        estatales, nacionales e internacionales aplicables. USTED NO PUEDE USAR
        EL SITIO SI NO ESTÁ DE ACUERDO CON ESTOS TÉRMINOS DE SERVICIO.
      </p>
      <p>
        Este Sitio utiliza cookies. Al usar el Sitio y aceptar los Términos de
        Servicio, usted consiente que Spur utilice cookies de acuerdo con los
        términos de la Política de privacidad de Spur.
      </p>
      <h2>Tabla de Contenidos</h2>
      <ol>
        <li>Ámbito de aplicación</li>
        <li>Registro, acceso y seguridad</li>
        <li>Términos específicos para los trabajadores</li>
        <li>Términos específicos de los lugares de trabajo</li>
        <li>
          Información del usuario, contenido generado por el usuario y
          restricciones de uso
        </li>
        <li>Política de privacidad</li>
        <li>Sin garantías</li>
        <li>Marcas registradas</li>
        <li>Aviso de infracción de derechos de autor</li>
        <li>Críticas, comentarios y otros contenidos</li>
        <li>Modificaciones</li>
        <li>
          Violación de las normas y reglamentos; Divulgación de información
        </li>
        <li>Indemnización</li>
        <li>Limitación de responsabilidad</li>
        <li>Sitios de terceros</li>
        <li>No existe relación fiduciaria</li>
        <li>Derecho a monitorear</li>
        <li>Comunicaciones electrónicas</li>
        <li>Ley aplicable y principios generales</li>
        <li>Arbitraje y acción colectiva</li>
        <li>RENUNCIA AL JUICIO POR JURADO</li>
        <li>Jurisdicción y lugar de celebración</li>
      </ol>
      <h3>Ámbito de aplicación</h3>
      <p>
        Spur, Inc. y sus filiales, subsidiarias, agentes, representantes,
        sucesores y cesionarios (colectivamente “<strong>Spur</strong>“, “
        <strong>nosotros”</strong>, “<strong>hemos</strong>” o “
        <strong>nuestro</strong>“) le proporcionan el Sitio a usted, el usuario
        del Sitio (“<strong>usted</strong>” o “<strong>su</strong>“) para su uso
        informativo, no comercial y sujeto a los Términos del Servicio. El uso
        de este Sitio para evaluar la posibilidad de entablar en una relación
        comercial con Spur no constituirá un uso comercial del Sitio. Es una
        violación de los Términos de Servicio que usted utilice el Sitio en
        violación de cualquier ley o reglamento o en violación de las reglas de
        cualquier proveedor de servicios de Spur. Ciertos otros programas o
        servicios proporcionados por Spur a través de sitios web enlazados u
        otros canales pueden tener términos y condiciones adicionales que
        gobiernan su uso de esos servicios, y nada en estos Términos de Servicio
        tiene la intención de modificar, limitar, o de otra manera perjudicar
        dichos términos de servicio.
      </p>
      <p>
        Spur es una compañía de servicios de personal en el negocio de aplicar
        su juicio profesional para proporcionar herramientas y otros recursos
        para determinar las parejas óptimas de trabajadores de servicio y
        aquellos que necesitan servicios relacionados. El Sitio es una
        plataforma de comunicaciones basada en la web, que permite a los
        Trabajadores y a los Lugares de Trabajo conectarse. Los “
        <strong>Lugares de Trabajo</strong>” son individuos o entidades
        comerciales que buscan obtener servicios temporales (“
        <strong>Empleos</strong>“) de los Trabajadores a través de Spur. Los “
        <strong>Trabajadores</strong>” son individuos empleados por Spur con el
        propósito de realizar uno o más Trabajos para uno o más Lugares de
        Trabajo. Los trabajadores y los lugares de trabajo en su conjunto se
        denominarán en lo sucesivo “<strong>usuarios</strong>“.
      </p>
      <p>
        Como se describe más adelante en estos Términos de Servicio, cuando un
        Trabajador se compromete a través de Spur para realizar un Trabajo para
        un Lugar de Trabajo, el Trabajador será en todo momento durante dicho
        Trabajo un empleado de Spur y no será un empleado del Lugar de Trabajo.
        El Lugar de Trabajo no puede contratar ni despedir a ningún empleado de
        Spur. Spur se reserva el derecho exclusivo de contratar y despedir a los
        trabajadores. Lo anterior no limitará el derecho del Lugar de Trabajo,
        tal como se estipula en este documento, de terminar cualquier Trabajo o
        solicitar que Spur provea a un Trabajador de reemplazo para un Trabajo.
        En caso de que Spur despida a un Trabajador durante un Trabajo, Spur
        hará todo lo posible para ofrecer al Lugar de Trabajo un Trabajador
        sustituto tan pronto como sea posible, en ese momento, a menos que Spur
        haya indicado lo contrario, el Trabajador sustituto deberá ser
        contratado por el Lugar de Trabajo utilizando el mismo proceso que se
        utiliza para un nuevo Trabajo, tal como se describe a continuación.
      </p>
      <p>
        Debido a la naturaleza de Internet, Spur no puede garantizar la
        disponibilidad y accesibilidad continua e ininterrumpida del Sitio.
        Podemos restringir la disponibilidad del Sitio o de ciertas áreas o
        características del mismo, a nuestro exclusivo criterio, incluso cuando
        hayamos determinado que dichas restricciones son necesarias para abordar
        los límites de capacidad, la seguridad o integridad de nuestros
        servidores, para llevar a cabo medidas de mantenimiento que garanticen
        el funcionamiento adecuado o mejorado del Sitio o nuestro cumplimiento
        requerido con cualquier ley, reglamento o mandato de una agencia
        gubernamental. El Sitio también puede verse afectado por actividades o
        eventos fuera de nuestro control, tales como interrupciones o problemas
        del proveedor de servicios de Internet, incendios, guerras, accidentes,
        casos fortuitos o actos de terrorismo. Además, es posible que mejoremos,
        actualicemos o modifiquemos el Sitio e introduzcamos nuevos servicios de
        vez en cuando.
      </p>
      <h3>Registro, acceso y seguridad</h3>
      <p>
        Si usted utiliza cualquier servicio de Spur y nos proporciona cualquier
        información a través del Sitio, como su nombre, número de seguro social,
        experiencia laboral previa, antecedentes educativos, fecha de
        nacimiento, antecedentes penales, información de cuentas bancarias,
        información de tarjetas de crédito, número de identificación de empleo
        federal, estado civil, dirección, código postal, número de teléfono,
        detalles de contacto, dirección de correo electrónico y/o Su contraseña
        (colectivamente denominado, su “<strong>Información de Usuario</strong>
        “) para cualquier cuenta asociada con usted (“
        <strong>Su(s) Cuenta(s)”</strong>), usted acuerda proporcionar
        información verídica, precisa, actual, completa y actualizada. Si
        proporciona cualquier información que sea falsa, inexacta,
        desactualizada o incompleta, o tenemos motivos razonables para sospechar
        que dicha información es falsa, inexacta, no actual o incompleta,
        entonces tenemos el derecho de terminar o rechazar cualquier y todo
        acceso o uso actual o futuro del Sitio (o cualquier parte de este).
      </p>
      <p>
        Nos reservamos el derecho de tomar cualquier medida que consideremos
        necesaria para garantizar la seguridad del Sitio y de Su Cuenta,
        incluyendo, sin limitación, el cambio de contraseña, la cancelación de
        Su Cuenta o la solicitud de información adicional para autorizar
        transacciones en Su Cuenta. Usted es el único responsable de mantener la
        confidencialidad de Su Información de Usuario y de cualquier pregunta de
        seguridad y respuesta asociada con Su Cuenta. Cualquier persona con
        conocimiento o acceso a Su Información de Usuario o a las preguntas y
        respuestas de seguridad asociadas con Su Cuenta puede usar esa
        información para obtener acceso a Su Cuenta.
      </p>
      <p>
        Usted es el único responsable de cualquier reclamo, daño, pérdida, costo
        u otras responsabilidades que resulten de o sean causadas por el hecho
        de no mantener la confidencialidad de su información de usuario y de las
        preguntas y respuestas de seguridad, ya sea que dicha falla ocurra con o
        sin su conocimiento o consentimiento. Usted debe notificarnos
        inmediatamente de cualquier acceso o uso no autorizado sospechado o real
        de Su Cuenta, su Información de Usuario, o cualquier otra violación de
        la seguridad de Su Cuenta. Usted autoriza y da su consentimiento para
        que Spur y sus proveedores de servicios recopilen, almacenen, compartan,
        usen, transfieran y vendan cualquier información y datos relacionados o
        derivados de su uso del Sitio.
      </p>
      <p>
        Usted es responsable de proporcionar y mantener, bajo su propio riesgo,
        opción y gasto, cualquier hardware, software y líneas de comunicación
        necesarias para acceder y utilizar el Sitio. Spur se reserva el derecho
        de cambiar la configuración de acceso al Sitio en cualquier momento, sin
        previo aviso.
      </p>
      <h3>Términos específicos para los trabajadores</h3>
      <p>
        NINGUNA DE ESTAS CONDICIONES DE USO ESTÁ DISEÑADO PARA CREAR UN CONTRATO
        DE TRABAJO. USTED SERÁ UN EMPLEADO “A VOLUNTAD” DE SPUR, LO QUE
        SIGNIFICA QUE LA RELACIÓN LABORAL CON SPUR PUEDE SER TERMINADA POR USTED
        O POR NOSOTROS EN CUALQUIER MOMENTO, CON O SIN CAUSA Y SIN PREVIO AVISO.
        LOS TRABAJOS SON ACEPTADOS CON EL ENTENDIMIENTO DE QUE NINGUNA GARANTÍA
        O PROMESA DE LA DURACIÓN DE LA ASIGNACIÓN SE OFRECE O IMPLICA.
      </p>
      <p>
        Usted reconoce y acepta que el Sitio es para uso exclusivo de los
        Trabajadores que pueden establecer una relación laboral con Spur y, como
        empleado de Spur, realizar Trabajos para Lugares de Trabajo que
        involucran al Trabajador a través del Sitio. Su estado como empleado de
        Spur está expresamente supeditado a que usted no tenga ningún acuerdo
        laboral vinculante de empleadores anteriores u otras restricciones
        legales que le impidan convertirse en un Trabajador o de lo contrario,
        aceptar un Trabajo con un Lugar de Trabajo, su prueba de derecho a
        trabajar en los Estados Unidos, y completar una investigación de
        antecedentes exitosa, que generalmente se realiza antes de que usted sea
        contratado como empleado de Spur.
      </p>
      <p>
        Para calificar para ciertos Trabajos, es posible que se le exija que
        complete con éxito una investigación de antecedentes más exhaustiva que
        la que realizamos en el momento de la contratación inicial por parte de
        Spur, o que proporcione los resultados de un examen de detección de
        drogas negativo o pruebas de que posee una licencia especializada, que
        ha recibido cierta capacitación o que posee otras certificaciones, o que
        se le exija que acepte ciertos acuerdos de confidencialidad, no
        captación, trabajos hechos por contrato u otros acuerdos de convenio
        restrictivos con el lugar de trabajo. Si decide solicitar estos puestos
        de Trabajo, usted es responsable de satisfacer estos requisitos
        adicionales a su exclusivo costo. Spur no será responsable de ningún
        gasto relacionado.
      </p>
      <h4>Nuestra Relación:</h4>
      <p>
        Al aceptar estos Términos de Servicio, usted acepta que es un empleado a
        voluntad de Spur. Durante cualquier Trabajo con un Lugar de Trabajo, su
        relación con ese Lugar de Trabajo será como un Trabajador de Espuela
        colocado (un “<strong>Trabajador Colocado</strong>“), y no como empleado
        del Lugar de Trabajo. Como resultado, no tendrá derecho a ningún derecho
        de un empleado con respecto a ningún Lugar de Trabajo.
      </p>
      <p>
        Usted no puede subcontratar ningún trabajo, sin el consentimiento previo
        por escrito de Spur y el lugar de trabajo que publicó el trabajo.
      </p>
      <p>Como empleado de Spur, usted reconoce y acepta:</p>
      <ul>
        <li>
          completar cualquier entrenamiento obligatorio que podamos requerir de
          vez en cuando,
        </li>
        <li>
          cumplir con todas las reglas de trabajo, códigos de vestimenta, código
          de conducta, medidas de seguridad y otras políticas aplicables
          establecidas en el Manual del Empleado de Spur u otras políticas
          adoptadas por Spur, que pueden ser enmendadas de vez en cuando y
          estarán disponibles para usted en el Sitio,
        </li>
        <li>
          ponerse en contacto con Spur en relación con cualquier queja o
          inquietud que pueda tener sobre un Trabajo o Lugar de Trabajo o las
          acciones u omisiones del personal del Lugar de Trabajo o Spur, y
        </li>
        <li>
          proporcionar servicios a cualquier Lugar de Trabajo solo de
          conformidad con el trabajo que usted haya aceptado y no realizar
          servicios adicionales para dicho lugar de trabajo a menos que se haya
          obtenido la aprobación previa por escrito de Spur o que se haya
          publicado un nuevo trabajo en nuestro sitio y haya sido debidamente
          aceptado por usted.
        </li>
      </ul>
      <h4>Compensación y beneficios para empleados:</h4>
      <p>
        Mientras que el lugar de trabajo establece la tarifa por hora real
        pagada por un trabajo en particular, Spur se reserva el derecho
        exclusivo de establecer los honorarios totales que debe pagar un Lugar
        de Trabajo para estimular los salarios en relación con cualquier
        trabajo, y asume la responsabilidad de deducir los honorarios de Spur y
        luego pagarle los salarios resultantes a su debido tiempo, y de retener
        y depositar toda la compensación por desempleo, la retención de
        impuestos sobre la renta y otros impuestos de nómina, así como otras
        retenciones de dichas cantidades, según lo exija la ley o el contrato.
        Como su empleador, Spur tiene la discreción exclusiva para determinar si
        se le ofrecerán beneficios a usted y los términos de los mismos.
        Cualquiera de estos beneficios para empleados estará sujeto en todo
        momento a los términos y condiciones establecidos en los documentos que
        rigen dichos beneficios, los cuales podrán ser modificados o cancelados,
        a nuestra entera discreción, en cualquier momento. Si usted trabaja
        suficientes horas a través de Trabajos para ser considerado un “empleado
        de tiempo completo” de Spur a los fines de la Ley de Cuidado de Salud
        Asequible, Spur será responsable de ofrecerle cobertura médica
        calificada.
      </p>
      <p>
        Usted no tendrá derecho en ningún momento a ningún beneficio o
        prerrequisito ofrecido por un Lugar de Trabajo, excepto cuando se
        acuerde específicamente por escrito entre Spur y el Lugar de Trabajo, en
        cuyo caso solo el Lugar de Trabajo y no Spur será responsable de la
        provisión de los beneficios o prerrequisitos acordados.
      </p>
      <h4>Seguro de responsabilidad:</h4>
      <p>
        Spur es responsable de mantener el seguro de compensación de
        trabajadores para usted, como lo requiere la ley. También compramos
        seguros de responsabilidad civil general, profesionales y de prácticas
        de empleo que ofrecen protección para nosotros y para nuestra fuerza
        laboral contra ciertas reclamaciones.
      </p>
      <h4>Convenios restrictivos/confidencialidad:</h4>
      <p>
        Por la presente, usted representa, hace un convenio y garantiza que no
        está cubierto por ningún convenio restrictivo (“
        <strong>convenio restrictivo</strong>“), incluyendo, pero no limitado a,
        un acuerdo de no competencia, no solicitud o no divulgación, que
        prohibiría su empleo por parte de Spur. Usted está de acuerdo que no
        aceptará ningún Trabajo que viole ningún convenio restrictivo al que
        esté o pueda estar sujeto en la actualidad. Usted reconoce que no
        tenemos la capacidad ni la obligación de realizar una evaluación previa
        o validar ninguna información relacionada con cualquier convenio
        restrictivo al que pueda estar sujeto ahora o en el futuro, y que el
        cumplimiento de dicho convenio restrictivo es de su exclusiva
        responsabilidad.
      </p>
      <p>
        Usted reconoce que durante el curso de su empleo con Spur, puede estar
        expuesto o tener acceso a, o Spur o un Lugar de Trabajo puede revelar o
        proporcionarle Secretos Comerciales e Información Confidencial. Los
        Secretos Comerciales y la Información Confidencial de Spur y de cada
        Lugar de Trabajo son propiedad única y exclusiva de Spur o de dicho
        Lugar de Trabajo (según corresponda). La revelación de cualquier Secreto
        Comercial e Información Confidencial no le dará ninguna licencia,
        interés o derechos de ningún tipo en o para los Secretos Comerciales o
        Información Confidencial. Usted acepta que toda la información
        confidencial que obtenga de o acerca de un Lugar de Trabajo mientras
        responde a o durante un trabajo no debe ser comunicada o compartida con
        nadie más que el personal autorizado de ese Lugar de Trabajo. Además, su
        tarifa de pago y los beneficios con Spur se consideran asuntos
        confidenciales entre usted y Spur, y a falta de una razón convincente
        para lo contrario, no deben ser revelados a terceros, incluyendo el
        personal de ningún Lugar de Trabajo.
      </p>
      <p>
        Usted acepta indemnizar, defender y eximir a Spur y a cada Lugar de
        Trabajo de cualquier demanda, reclamo u otro gasto que surja de o esté
        relacionado con su violación o supuesta violación de dicho convenio
        restrictivo o de las restricciones de confidencialidad mencionadas
        anteriormente.
      </p>
      <h4>Puestos de trabajo, frecuencia y tarifas de pago:</h4>
      <p>
        Usted reconoce y acepta que los Lugares de Trabajo son los únicos
        responsables de publicar trabajos en el sitio. Spur no está obligado a
        monitorear la publicación de Empleos, la fuente de los Empleos, el
        número de Empleos publicados, o su frecuencia. Usted acepta que el Lugar
        de Trabajo controla únicamente la publicación y disponibilidad de
        Empleos a su discreción. Spur no garantiza que se pondrá a su
        disposición ninguna cantidad de Empleos a través del Sitio, ya que la
        disponibilidad depende totalmente de la demanda del Lugar de Trabajo,
        que puede disminuir en cualquier momento y por cualquier motivo.
      </p>
      <p>
        El Lugar de Trabajo establece la tarifa de pago por hora para los
        trabajos reservados a través de Spur. Usted reconoce y acepta que Spur
        no está involucrado en el establecimiento de ninguna de estas tarifas,
        aparte de requerir que el Lugar de Trabajo satisfaga las tarifas del
        salario mínimo por hora y las horas extras requeridas por las leyes
        federales, estatales o locales aplicables. Los empleados tienen derecho
        a pago de horas extras bajo las disposiciones específicas de la ley
        federal a una tasa de 1 y ½ veces la tasa horaria del empleado a la que
        se realizaron las horas extras por el tiempo trabajado en exceso de 40
        horas por semana laboral. No seremos responsables de ningún problema o
        disputa que surja con respecto a los Trabajos publicados en el Sitio.
        Además, Spur no está obligado a revisar o anular la decisión de un Lugar
        de Trabajo de rechazar la oferta de un Trabajador de aceptar un Trabajo
        o el rechazo de un Trabajador o de un Lugar de Trabajo a un Trabajador,
        ya sea por incumplimiento, desempeño insatisfactorio u otras razones, y
        Spur no será responsable de ninguna de estas decisiones en el Lugar de
        Trabajo.
      </p>
      <p>
        A menos que se indique específicamente en un anuncio de trabajo o que lo
        exija la ley, no se pagará una tarifa de pago especial si un Trabajo se
        realiza en un día festivo.
      </p>
      <p>
        Usted reconoce y acepta que Spur limita el número de horas que puede
        trabajar en un día o semana laboral. Nuestra jornada laboral comienza a
        las 12:01 a.m. y termina a las 12:00 a.m., y nuestra semana laboral
        comienza a las 12:01 a.m. cada lunes y termina a las 12:00 a.m. del
        domingo siguiente, en el huso horario en el que se realiza el Trabajo
        (o, si se realiza virtualmente o de forma remota, en la ubicación de la
        sede del Lugar de Trabajo). Actualmente le limitamos a treinta y ocho
        (38) horas por semana laboral.
      </p>
      <p>
        No se le permite trabajar más allá de las horas indicadas en el Trabajo
        que ha aceptado en nuestro Sitio.
      </p>
      <h4>Verificación de antecedentes, autorización y liberación:</h4>
      <ul>
        <li>
          Verificación de antecedentes: Nosotros o nuestros agentes o
          representantes designados podemos solicitar información de
          antecedentes acerca de usted a una agencia de informes del consumidor
          en relación con su solicitud de utilizar el Sitio para fines laborales
          y/o su presentación para ciertos Trabajos a través del Sitio. La Ley
          de Informes de Crédito Justos (Fair Credit Reporting Act, la “
          <strong>FCRA</strong>“) define dicho informe, incluyendo los informes
          investigativos de los consumidores según se definen en la FCRA, como
          un “Informe del Consumidor”, y todas las consultas se limitan a la
          información que afecta a su desempeño de posibles Empleos a través de
          nuestro Sitio. Todas las solicitudes se llevan a cabo de conformidad
          con las leyes aplicables, incluida la FCRA. Usamos una agencia externa
          para esta investigación: Yardstik, Inc., 100 Washington Ave S, Suite
          600, Minneapolis, MN 55401, Teléfono: 1-888-278-5042. Como resultado,
          Yardstik puede obtener un Informe del Consumidor sobre usted como
          usuario del Sitio.
        </li>
        <li>
          Autorización y Liberación: De conformidad con la Ley de Informes de
          Crédito Justos de los Estados Unidos, usted autoriza a Spur y a sus
          agentes y representantes designados a llevar a cabo una revisión
          exhaustiva de sus antecedentes a través de un Informe del Consumidor
          y/o un informe investigativo del consumidor que se generará para ser
          preseleccionado como un Trabajador autorizado a usar nuestro Sitio y
          según se requiera para calificar para ciertos Trabajos a través de
          nuestro Sitio. Al aceptar estos Términos de Servicio, usted reconoce y
          acepta que ha leído y entendido cuidadosamente esta divulgación para
          la obtención de Informes del Consumidor. Usted también entiende que la
          información contenida en su perfil o divulgada por usted antes o
          durante su uso de nuestro Sitio, si la hubiera, puede ser utilizada
          con el propósito de obtener Informes del Consumidor y/o informes
          investigativos del consumidor. Al aceptar estos Términos de Servicio,
          usted autoriza a las agencias encargadas de hacer cumplir la ley,
          instituciones de aprendizaje (incluyendo escuelas y universidades
          públicas y privadas), oficinas de servicios de información, agencias
          de crédito, registros/repositorios de datos, tribunales (federales,
          estatales, locales o internacionales), agencias de registros de
          vehículos automotores, sus empleadores anteriores o actuales, las
          fuerzas armadas y otras personas y fuentes para que proporcionen toda
          la información sobre usted que solicite la agencia de informes del
          consumidor. Usted certifica que la información que proporciona para
          que Spur o sus agentes o representantes designados puedan obtener un
          Informe del Consumidor es verdadera y correcta y será válida para
          cualquier informe que pueda ser solicitado por o en nombre de Spur.
        </li>
      </ul>
      <p>
        Usted acepta que ciertos Trabajos pueden exigirle que cumpla con una
        verificación de antecedentes adicional, en cuyo caso, su solicitud para
        dicho Trabajo será considerada como su autorización para obtener
        cualquier informe adicional requerido por dicho Trabajo.
      </p>
      <p>Pago por trabajos completados:</p>
      <p>
        Una vez que haya aceptado un Trabajo a través del Sitio, se le pedirá
        que inicie y finalice el Trabajo a través del Sitio para registrar el
        tiempo trabajado. Una vez que termine el trabajo, el lugar de trabajo
        tiene 24 horas para revisar el tiempo ingresado. Cualquier tiempo que se
        considere incorrecto puede ser disputado por el Lugar de Trabajo o por
        usted. Si el tiempo ingresado no es disputado por ninguna de las partes
        dentro de las 24 horas, el Trabajo se cierra automáticamente, el Lugar
        de Trabajo será responsable de los Cargos Totales, y usted solo tendrá
        derecho a la cantidad de la tarifa por hora acordada multiplicada por
        las horas registradas menos cualquier retención aplicable por ley o
        contrato. En casos limitados, un lugar de trabajo puede tener un período
        de tiempo más largo para la revisión, pero solo si se establece en un
        acuerdo escrito entre el lugar de trabajo y Spur.
      </p>
      <p>
        Después de que usted haya indicado su terminación del Trabajo, y después
        de que el Lugar de Trabajo haya calificado el trabajo e indicado su
        aceptación de la terminación de dicho Trabajo a través del Sitio, los
        fondos se le pagarán semanalmente por medio de un depósito directo en la
        cantidad acordada en el momento de la aceptación del Trabajo.
      </p>
      <p>
        La inscripción en depósito directo es voluntaria y no es una condición
        para contratar o continuar el empleo con Spur. El no inscribirse en
        depósito directo no afectará negativamente los términos o condiciones de
        su empleo con Spur de ninguna manera. Si desea inscribirse en depósito
        directo, puede seleccionar la institución financiera que recibe el
        depósito completando oportunamente la información necesaria en el Sitio.
      </p>
      <h4>Calificaciones y desempeño:</h4>
      <p>
        Los trabajadores son clasificados por el Lugar de Trabajo al final de un
        Trabajo. El único medio de evaluación del rendimiento está en el sistema
        de calificación proporcionado a través del Sitio. Mantenemos el derecho
        de revisar el desempeño o participar en cualquier acción disciplinaria.
        Dentro de un cierto período de tiempo después de completar un trabajo,
        el Lugar de Trabajo puede presentar una calificación (“
        <strong>Calificación</strong>“) sobre usted. Cualquier calificación
        refleja la opinión del usuario autorizado del Lugar de Trabajo y no
        refleja la opinión de Spur.
      </p>
      <p>
        Dentro de un cierto período de tiempo después de completar un trabajo,
        usted puede enviar una calificación (también una “
        <strong>Calificación</strong>“) sobre el Lugar de Trabajo. Cualquier
        calificación refleja la opinión del Trabajador y no refleja la opinión
        de Spur. Las calificaciones de los Trabajadores y Lugares de Trabajo
        deben ser justas, veraces y objetivas.
      </p>
      <p>
        Se prohíbe a los Trabajadores y Lugares de Trabajo manipular el sistema
        de calificaciones de cualquier manera, como instruir a un trabajador o
        lugar de trabajo para que responda positiva o negativamente sobre otro
        Trabajador o Lugar de Trabajo.
      </p>
      <p>
        Usted renuncia a cualquier demanda, reclamo o acción contra Spur por
        difamación, injuria, calumnia, difamación o cualquier otro agravio
        relacionado con o derivado de la nueva publicación de cualquier
        Clasificación por parte de Spur, y por la presente acepta indemnizar,
        defender y mantener a Spur indemne por cualquier demanda, reclamo o
        acción que surja de su Clasificación de cualquier Lugar de Trabajo.
      </p>
      <h4>Garantías y representaciones adicionales:</h4>
      <p>
        Por la presente, usted garantiza, representa y acepta que, en cada
        aceptación de un trabajo:
      </p>
      <ul>
        <li>
          Usted es capaz de completar el Trabajo de acuerdo con los requisitos
          del Trabajo publicados en el Sitio;
        </li>
        <li>
          Las habilidades, experiencia, antecedentes y otra información
          contenida en su perfil es precisa y no engañosa;
        </li>
        <li>
          Usted no ha excedido las horas máximas de trabajo permitidas por Spur
          (como se describió anteriormente) para ese día o semana laboral.
        </li>
      </ul>
      <h3>Términos específicos de los lugares de trabajo:</h3>
      <p>
        Si usted está de acuerdo con estos Términos de Servicio en nombre de un
        Lugar de Trabajo, usted declara y garantiza lo siguiente:
      </p>
      <p>
        Declara que tiene la autoridad para vincular el Lugar de Trabajo (ya sea
        una persona o entidad legal) a los Términos de Servicio y, en tal caso,
        “<strong>usted</strong>” y “<strong>su</strong>” se referirán y
        aplicarán a esa persona o entidad legal que sirve como Lugar de Trabajo.
      </p>
      <p>
        Reconoce y acepta que el Sitio está destinado a ser utilizado únicamente
        por los Lugares de Trabajo que pueden solicitar y utilizar Trabajadores
        temporales a través del Sitio.
      </p>
      <p>
        Mientras que usted es responsable de decidir los requisitos de un
        Trabajo, de determinar el precio a pagar por un Trabajo (sujeto a los
        requisitos de Spur) y de supervisar el desempeño del Trabajador durante
        el Trabajo, Spur será en todo momento el empleador del Trabajador que
        realiza el Trabajo. Como tal, somos los únicos responsables de
        contratar, despedir y disciplinar al Trabajador, procesar las entradas
        de tiempo y la compensación resultante del Trabajador, proporcionar
        beneficios de empleado (si los hay) al Trabajador, proporcionar
        capacitación periódica o continua a los Trabajadores, y llevar a cabo la
        evaluación general del Trabajador con el fin de determinar si él o ella
        puede continuar usando nuestro Sitio. Spur es la única entidad
        responsable de recibir quejas de los Trabajadores con respecto a los
        Trabajos o de otra manera y de notificar a los Trabajadores de la
        terminación o cambio de su Trabajo asignado. Se requiere que los
        trabajadores cumplan con el Manual del Empleado de Spur y otras
        políticas y procedimientos de Spur, según se adopten de vez en cuando y
        estén disponibles en nuestro Sitio.
      </p>
      <h4>Declaración de Impuestos y Pagos:</h4>
      <p>
        El Lugar de Trabajo entiende y acepta que los Trabajadores son empleados
        de Spur. Spur recogerá un Formulario W-4 de cada Trabajador. Spur asume
        la responsabilidad de pagar tales salarios al Trabajador cuando se
        venza, y de retener y depositar todos los impuestos de nómina y otras
        retenciones de tales cantidades como lo requiere la ley.
      </p>
      <h4>Beneficios y retenciones para empleados:</h4>
      <p>
        Como empleador, Spur tiene la discreción exclusiva para determinar si se
        ofrecerán beneficios de empleado a un Trabajador y los términos de los
        mismos. Un Trabajador no tendrá derecho en ningún momento a ningún
        beneficio o requisito ofrecido por un Lugar de Trabajo. Usted acuerda no
        avisar ni representar a ningún Trabajador que dicho Trabajador estará
        cubierto o podrá participar en cualquier plan de beneficios para
        empleados mantenido por usted o sus afiliados.
      </p>
      <h4>I-9 y E-Verify:</h4>
      <p>
        Como empleador, Spur verifica la identidad y autorización de empleo de
        cada Trabajador a través del Formulario I-9 y E-Verify.
      </p>
      <h4>Seguro:</h4>
      <p>
        Spur mantiene los seguros generales, generales, profesionales, de
        delitos, de tecnología y omisiones, y las prácticas de responsabilidad
        civil. Usted puede solicitar una copia del Certificado de Seguro de Spur
        poniéndose en contacto con el Departamento Legal de Spur en P.O. Box
        107, Huntsville, Alabama 35804 o por correo electrónico a{' '}
        <a href="mailto:legal@spurstaffing.com">legal@spurstaffing.com</a>.
      </p>
      <p>
        No proporcionamos ninguna cobertura de seguro a Lugares de Trabajo, como
        seguro de responsabilidad civil general comercial, profesional o de
        prácticas de empleo, o seguro de compensación de trabajadores.
      </p>
      <h4>Nuestra relación:</h4>
      <p>
        Al aceptar los Términos de Servicio, usted reconoce que la relación
        entre usted y Spur es una relación de contratista independiente. Nada en
        este Acuerdo será considerado para crear cualquier forma de sociedad,
        principal-agente, empleador-empleado, o relación de co-empleo, o empresa
        conjunta, entre usted, Spur o el Trabajador.
      </p>
      <p>
        Spur no es una Organización Profesional de Empleadores como se define en
        el Código de Rentas Internas y en las regulaciones promulgadas bajo el
        mismo.
      </p>
      <h4>Trabajadores:</h4>
      <p>
        Usted reconoce que los trabajadores son empleados de Spur para los
        propósitos de todas las leyes federales, estatales y locales de empleo.
        Sin embargo, usted está de acuerdo con los términos de indemnización que
        se describen a continuación en “Indemnización”, los cuales incluirían su
        indemnización por cualquier violación de las leyes laborales por su
        parte o por parte de su personal u otros agentes.
      </p>
      <h4>Cumplimiento de OSHA:</h4>
      <p>
        Usted declara y garantiza que la ubicación física de cualquier trabajo
        cumplirá con todas las regulaciones aplicables de la Administración de
        Seguridad y Salud Ocupacional (OSHA) vigentes en el momento en que el
        Trabajador realiza el trabajo. Excepto donde lo prohíba la ley aplicable
        o donde se establezca en un acuerdo escrito separado firmado por un
        oficial de Spur, usted acuerda indemnizar, defender y mantener indemne a
        Spur de demandas, reclamos u otros gastos que surjan de una violación o
        supuesta violación de cualquier regulación de OSHA que surja de
        cualquier trabajo o del uso que usted haga del Sitio, incluyendo, pero
        sin limitarse a, los honorarios de los abogados de Spur, los costos de
        la corte o las multas impuestas por un organismo gubernamental. Además,
        usted acepta permitir que un representante de Spur lleve a cabo una
        revisión in situ de las instalaciones donde se realizará un trabajo si
        Spur decide, a su entera discreción, que dicha revisión es necesaria o
        aconsejable.
      </p>
      <h4>Aceptación del trabajo:</h4>
      <p>
        Usted reconoce que es el único responsable de publicar Empleos en el
        Sitio. Spur no está obligado a controlar la publicación de Empleos, el
        origen de los Empleos, el número de Empleos o su frecuencia. El Lugar de
        Trabajo acuerda que los Trabajadores controlan la aceptación de los
        Trabajos a su entera discreción. Spur no garantiza ninguna tasa de
        aceptación de Trabajos, que cualquier Trabajo en particular será
        aceptado, o que cualquier Trabajador específico aceptará un Trabajo, ya
        que la aceptación de Trabajos depende totalmente de los Trabajadores.
        Spur no garantiza que los puestos de trabajo de un Lugar de Trabajo
        serán ocupados por Trabajadores o cualquier Trabajador específico en el
        Sitio.
      </p>
      <h4>
        Verificaciones de antecedentes y exención de responsabilidad de la
        garantía:
      </h4>
      <ul>
        <li>
          **Verificaciones de Antecedentes:** Nosotros o nuestros agentes o
          representantes designados realizamos verificaciones de antecedentes de
          todos los Trabajadores de una agencia de informes del consumidor en
          relación con su solicitud de utilizar el Sitio para fines laborales.
          Usted reconoce que Spur verifica los antecedentes de cada Trabajador
          utilizando un servicio de verificación de antecedentes de terceros que
          incluye, pero no se limita a, una verificación de registro de
          delincuentes sexuales, verificación de antecedentes penales en el
          condado, estado, federal y nacional, y verificación de la lista de
          vigilancia de terroristas nacionales e internacionales. Usted reconoce
          que, en la medida en que Spur o su agente o representante designado
          lleve a cabo una verificación de antecedentes, lo hace solo cuando el
          Trabajador es contratado inicialmente por Spur. Se realizarán
          verificaciones de antecedentes adicionales para tipos de trabajo
          específicos de conformidad con un acuerdo por separado entre usted y
          Spur como parte del requisito de credencial de ese trabajo.
        </li>
        <li>
          Spur tiene sus propios estándares mínimos internos para los
          trabajadores, que aplicamos a las verificaciones de antecedentes
          realizadas. Nuestros estándares internos son privados y sensibles y
          pueden cambiar de vez en cuando. Nuestros estándares están diseñados
          para cumplir con la ley federal y para asegurar un cierto nivel mínimo
          de calificación bajo los propios criterios de Spur. Sin embargo, Spur
          no declara que los Trabajadores que satisfacen los estándares de Spur
          para la verificación de antecedentes nunca hayan cometido un crimen,
          hayan sido arrestados, hayan experimentado problemas de crédito, hayan
          sido declarados en bancarrota, o de otra manera hayan participado en
          actividades que usted considere no útiles para el Trabajo o su Lugar
          de Trabajo.
        </li>
      </ul>
      <h4>Pagos a los trabajadores:</h4>
      <p>
        Una vez que un Trabajador ha aceptado un Trabajo a través del Sitio, se
        le pedirá al Trabajador que inicie y finalice el Trabajo en el Sitio
        para registrar el tiempo trabajado. Una vez que el Trabajador haya
        completado el Trabajo e indicado dicha finalización, procesaremos y
        pagaremos al Trabajador en base a la tarifa de Trabajo acordada entre el
        Trabajador y el Lugar de Trabajo en el momento de la aceptación del
        Trabajo. El pago se hará semanalmente.
      </p>
      <p>
        Al aceptar estos Términos de Servicio, el Lugar de Trabajo acuerda que
        la tarifa a ser pagada por hora por el Lugar de Trabajo, menos nuestra
        porción de tales tarifas, cumplirá con todas las leyes federales,
        estatales y locales aplicables de salario mínimo. Esto significa que la
        compensación mínima por hora a ser pagada a un Trabajador (después de la
        deducción de nuestros honorarios) por un Lugar de Trabajo será de $7.25
        por hora, a menos que las leyes aplicables de salario mínimo requieran
        una compensación por hora más alta, en cuyo caso la compensación por
        hora más alta será la compensación mínima por hora pagada a un
        Trabajador (después de la deducción de nuestros honorarios).
      </p>
      <h4>
        Tarifa por hora, método de pago y errores de procesamiento de pagos:
      </h4>
      <ul>
        <li>
          **Tarifa por hora:** El lugar de trabajo establece la tarifa de pago
          por hora para los trabajos reservados a través de Spur, siempre que,
          como se describe anteriormente, el salario pagado al trabajador
          (después de la deducción de la tarifa de Spur) satisfaga nuestros
          requisitos de tarifa mínima y el salario mínimo federal, estatal y
          local aplicable y otras leyes aplicables. El Trabajador comenzará y
          terminará cada Trabajo a través del Sitio. Una vez que el Trabajador
          termina el Trabajo, el Lugar de Trabajo tiene 24 horas para revisar el
          tiempo ingresado. Cualquier tiempo que se considere incorrecto puede
          ser disputado tanto por el Lugar de Trabajo como por el Trabajador. Si
          el tiempo ingresado no es disputado por ninguna de las partes dentro
          de las 24 horas, el Trabajo se cierra automáticamente, el Lugar de
          Trabajo será responsable de los Cargos Totales, y el Trabajador solo
          tendrá derecho a la cantidad de la tarifa por hora acordada
          multiplicada por las horas registradas menos los impuestos y los
          costos de la Administración de Spur y cualquier retención aplicable
          por ley o contrato. En casos limitados, un lugar de trabajo puede
          tener un período de tiempo más largo para la revisión, pero solo si se
          establece en un acuerdo escrito entre el Lugar de Trabajo y Spur.
        </li>
        <li>
          **Cargo por turno extendido:** Se le cobrará un cargo por turno
          extendido por cualquier turno en el que el Trabajador trabaje 0.5
          horas después de la hora programada para dicho Trabajo, según se haya
          ingresado en el Sitio en el momento en que se publique el Trabajo. La
          tarifa por turno extendido es equivalente a 1.5 de la tarifa por hora
          del trabajo (incluyendo la tarifa de Spur).
        </li>
        <li>
          **Método de pago:** Usted puede elegir pagarnos ya sea automáticamente
          por tarjeta de crédito o por pago de la cámara de compensación
          automatizada (ACH), o podemos aprobar su facturación.
        </li>
        <li>
          **Tarjeta de crédito o ACH:** Cuando usted agrega o utiliza una nueva
          tarjeta de crédito o método de pago ACH, Spur puede verificar el
          método de pago autorizando una cantidad nominal que no exceda un dólar
          ($1), o una suma similar en la moneda local del método de pago. Cuando
          usted añade un método de pago durante la creación de la cuenta,
          automáticamente guardaremos ese método de pago en Su Cuenta para que
          pueda ser utilizado para una transacción futura. Tenga en cuenta que
          los métodos de pago implican el uso de terceros proveedores de
          servicios de pago. Su método de pago puede estar sujeto a términos y
          condiciones adicionales impuestas por el proveedor de servicios de
          pago de terceros aplicable. Por favor, revise estos términos y
          condiciones antes de utilizar un método de pago. Usted autoriza al
          tercero a almacenar la información de su método de pago y cargar su
          método de pago como se indica en estos términos de pago. Si la
          información de la cuenta de su método de pago cambia (por ejemplo,
          número de cuenta, número de ruta, fecha de vencimiento) es su
          responsabilidad actualizar la información para poder continuar usando
          el Sitio. Usted es el único responsable de la exactitud e integridad
          de la información de su método de pago. Spur no es responsable de
          ninguna pérdida sufrida por usted como resultado de información
          incorrecta sobre el método de pago que usted haya proporcionado.
        </li>
        <li>
          **Facturación:** Si usted es aprobado por Spur para la facturación, le
          facturaremos semanalmente en la dirección de correo electrónico del
          Lugar de Trabajo que figura en los archivos. Las facturas que no se
          paguen dentro de los 15 días de su emisión devengarán intereses a una
          tasa de 1.5% por mes (o, si corresponde, la ley local, estatal o
          federal exige una tasa de interés máxima más baja, dicha tasa de
          interés máxima). Un lugar de trabajo puede tener un término de pago
          diferente, pero solo si se establece en un acuerdo escrito entre el
          lugar de trabajo y Spur. Nos reservamos el derecho, a nuestro
          exclusivo criterio y discreción, de eliminar de forma permanente o
          temporal su acceso al Sitio si alguna factura permanece sin pagar 15
          días después de su emisión. Además, nos reservamos el derecho de
          asignar cualquier factura impagada a una agencia de cobros. Por la
          presente, usted renuncia a todas y cada una de las exenciones y acepta
          pagar todos los costos, honorarios de abogados y gastos incurridos en
          relación con cualquier esfuerzo de cobro.
        </li>
        <li>
          **Errores en el procesamiento de pagos:** Tomaremos medidas para
          rectificar cualquier error en el procesamiento de pagos del que
          tengamos conocimiento. Estos pasos pueden incluir acreditar o debitar
          (según corresponda) el mismo método de pago utilizado por usted para
          el pago original, de modo que usted termine pagando la cantidad
          correcta.
        </li>
      </ul>
      <h4>Calificaciones y desempeño:</h4>
      <p>
        Los trabajadores son clasificados por el Lugar de Trabajo al final de un
        Trabajo. El único medio de evaluación del rendimiento está en el sistema
        de calificación proporcionado a través del Sitio. Mantenemos el derecho
        de revisar el desempeño o participar en cualquier acción disciplinaria
        con respecto a cualquier Trabajador. Dentro de un cierto período de
        tiempo después de completar un trabajo, los Lugares de Trabajo pueden
        presentar una calificación sobre el Trabajador. Cualquier calificación
        refleja la opinión del usuario autorizado del Lugar de Trabajo y no
        refleja la opinión de Spur. Dentro de un cierto período de tiempo
        después de completar un Trabajo, el Trabajador puede presentar una
        Calificación sobre el Lugar de Trabajo. Cualquier calificación refleja
        la opinión del Trabajador y no refleja la opinión de Spur. Las
        calificaciones de los Trabajadores y Lugares de Trabajo deben ser
        justas, veraces y objetivas.
      </p>
      <p>
        Se prohíbe a los Trabajadores y Lugares de Trabajo manipular el sistema
        de calificaciones de cualquier manera, como instruir a un trabajador o
        lugar de trabajo para que responda positiva o negativamente sobre otro
        Trabajador o Lugar de Trabajo.
      </p>
      <p>
        Usted renuncia a cualquier demanda, reclamo o acción contra Spur por
        difamación, injuria, calumnia o cualquier otro agravio relacionado con o
        que surja de la nueva publicación de cualquier Calificación por parte de
        Spur, y, excepto cuando lo prohíba la ley aplicable o cuando se acuerde
        lo contrario por escrito y firmado por un oficial de Spur y usted, por
        la presente usted acuerda indemnizar, defender y eximir a Spur de toda
        responsabilidad por cualquier demanda, reclamo o acción que surja de su
        Calificación de cualquier Trabajador.
      </p>
      <h4>Garantías y representaciones adicionales:</h4>
      <p>Como Lugar de Trabajo, usted garantiza, representa y acepta que:</p>
      <ul>
        <li>
          El Trabajo como se describe en el Sitio es una presentación justa y
          precisa del trabajo que usted desea que el Trabajador realice;
        </li>
        <li>
          Usted ha proporcionado las descripciones, instrucciones, horarios y
          especificaciones necesarias al Trabajador en la Oferta de empleo en el
          Sitio;
        </li>
        <li>
          Cualquier descripción de la forma y alcance del puesto deseado es
          razonablemente precisa;
        </li>
        <li>
          La tasa de pago especificada en la aceptación del trabajo es correcta
          y aceptable para el lugar de trabajo;
        </li>
        <li>
          Todos los trabajos publicados por usted cumplen con las leyes
          federales, estatales y locales aplicables; y
        </li>
        <li>
          Usted cooperará con nosotros para cumplir con todos los requisitos
          legales que se aplican a nuestra relación laboral con los
          Trabajadores, incluyendo, entre otros, a proporcionar una adaptación
          razonable bajo la Ley de Estadounidenses con Discapacidades (ADA) y
          prevenir el acoso ilegal y cooperar en la investigación y no tomar
          represalias por cualquier acusación de acoso ilegal.
        </li>
      </ul>
      <h3>
        Información del usuario, contenido generado por el usuario y
        restricciones de uso
      </h3>
      <p>
        Usted reconoce que Spur tiene el derecho y la obligación de precalificar
        o validar la Información de Usuario que los Usuarios del Sitio envían en
        relación con el establecimiento de un perfil o cuenta con Spur o
        cualquier contenido enviado a Spur o publicado en nuestro Sitio (“
        <strong>Contenido Generado por el Usuario</strong>“). Usted es el único
        responsable de proporcionar información precisa, actual y completa en
        relación con cualquier Información de Usuario o Contenido Generado por
        el Usuario que publique en el Sitio o ponga a disposición a través de un
        Trabajo, y usted declara y garantiza que tiene todos los derechos
        necesarios para enviarnos dicha Información de Usuario o Contenido
        Generado por el Usuario.
      </p>
      <p>
        Para comercializar nuestros Sitios, Servicios y aplicaciones móviles,
        podemos utilizar la información que usted proporcionó en su perfil, como
        su nombre, foto, la fecha en que creó su cuenta, su historial de empleo
        y/o educación, trabajos anteriores que haya completado, o enviado,
        calificaciones de otros usuarios y autodescripción en nuestros
        materiales de marketing a terceros a quienes usted o sus agentes nos
        autorizan a revelar su información personal.
      </p>
      <p>
        Usted acepta no utilizar este Sitio para ningún otro uso que no sea para
        los fines comerciales para los que fue diseñado. Usted acepta no
        realizar ninguna de las siguientes acciones con respecto al Sitio o a
        cualquier servidor que proporcione alojamiento al Sitio, Información de
        Usuario o Contenido Generado por el Usuario. Usted acepta no utilizar el
        Sitio para cargar, publicar, enviar por correo electrónico, distribuir,
        transmitir, vincular, solicitar o poner a disposición de cualquier otro
        modo cualquier contenido o utilizar el Sitio de cualquier manera que:
      </p>
      <ul>
        <li>
          cargue o transmita cualquier publicidad no solicitada, material
          promocional, “correo basura”, “spam”, “correos en cadena”, “esquemas
          piramidales”, o cualquier otra forma de solicitud, comercial o de otro
          tipo;
        </li>
        <li>
          descompila, utiliza ingeniería inversa, desensambla, deriva el código
          fuente o descifra el Sitio o el servidor que alberga el Sitio;
        </li>
        <li>
          manipule o muestre de otra manera el Sitio utilizando tecnología de
          enmarcado, duplicación o tecnología de navegación similar o enlaces
          directos a cualquier parte del Sitio que no sea la página principal
          ubicada en{' '}
          <a href="https://spurstaffing.com/">www.spurstaffing.com;</a>
        </li>
        <li>
          utiliza cualquier robot, araña, raspador u otro medio automático o
          manual para acceder al Sitio o copiar cualquier contenido o
          información del Sitio;
        </li>
        <li>
          elimina, oscurece o altera cualquier aviso de propiedad (incluyendo
          cualquier aviso de derechos de autor o marca registrada) de Spur o de
          sus afiliados, socios, proveedores o licenciatarios;
        </li>
        <li>
          modifica, adapta, mejora, optimiza o hace que cualquier trabajo
          derivado del Sitio;
        </li>
        <li>
          inhabilita, sobrecargua, deteriora o interfiere o interrumpe de alguna
          otra manera el Sitio o cualquier hardware, software, sistema o red
          conectado con el Sitio;
        </li>
        <li>
          sondea, explora o prueba la vulnerabilidad o viola las medidas de
          autenticación del Sitio o de cualquier red o sistema relacionado;
        </li>
        <li>
          interfiere con el uso y disfrute del Sitio por parte de terceros;
        </li>
        <li>
          infringe los derechos de autor, marca registrada o cualquier derecho
          de propiedad o revela un secreto comercial o información confidencial
          en violación de un acuerdo de confidencialidad o de no divulgación;
        </li>
        <li>
          recopila, utiliza, descarga o copia de otro modo cualquier Información
          de Usuario o cualquier parte de la misma, o transmite, proporciona o
          distribuye de otro modo (ya sea o no mediante pago) dicha información
          a terceros;
        </li>
        <li>
          es fraudulento, malicioso o ilegal, no autorizado o contiene
          información, imágenes, materiales o descripciones difamatorias o
          ilegales;
        </li>
        <li>promueve o proporciona instrucciones para actividades ilegales;</li>
        <li>
          alienta cualquier conducta que constituya una ofensa criminal o que dé
          lugar a responsabilidad civil;
        </li>
        <li>
          disemina virus u otros códigos informáticos, archivos o programas que
          interrumpan, destruyan o limiten la funcionalidad de cualquier
          software o hardware informático;
        </li>
        <li>
          intenta obtener acceso no autorizado a cualquier otra cuenta, sistema
          informático o red conectada a cualquier servidor o sistema a través de
          la piratería informática, la extracción de contraseñas o cualquier
          otro medio;
        </li>
        <li>
          accede a sistemas, datos o información que Spur no pretende que sean
          accesibles para usted;
        </li>
        <li>
          difunde información de los empleados (como los números de seguro
          social) que estaría prohibida por la ley aplicable, si dicha difusión
          hubiera sido realizada por Spur; o
        </li>
        <li>
          de otra manera viola cualquier ley federal, estatal o local aplicable.
        </li>
      </ul>
      <h3>Política de privacidad</h3>
      <p>
        Su privacidad es importante para nosotros. Por favor, tómese un momento
        para revisar nuestra Política de privacidad, la cual explica las
        prácticas de Spur relacionadas con la recopilación y uso de Su
        Información de Usuario a través de o en conexión con el Sitio. La
        Política de privacidad está incorporada en estos Términos de Servicio, y
        rige nuestro uso de su Información de Usuario y cualquier otra
        información que usted nos envíe o ponga a nuestra disposición en
        relación con el Sitio. Nuestra Política de privacidad está disponible en{' '}
        <Link to="/privacy-policy">“Política de privacidad”</Link>.
      </p>
      <h3>Sin garantías</h3>
      <p>
        TODO EL CONTENIDO DEL SITIO SE LE PROPORCIONA “TAL CUAL”, “TAL COMO
        ESTÁ”, “TAL COMO ESTÁ DISPONIBLE” Y SPUR RECHAZA EXPRESAMENTE TODAS LAS
        GARANTÍAS Y CONDICIONES DE CUALQUIER TIPO, YA SEAN EXPRESAS O
        IMPLÍCITAS, INCLUIDAS, ENTRE OTRAS, LAS GARANTÍAS IMPLÍCITAS DE
        COMERCIABILIDAD, IDONEIDAD PARA UN FIN DETERMINADO Y NO INFRACCIÓN. SPUR
        NO GARANTIZA LA EXACTITUD, INTEGRIDAD, ACTUALIDAD O CONFIABILIDAD DE
        CUALQUIER CONTENIDO DISPONIBLE A TRAVÉS DEL SITIO. USTED ES RESPONSABLE
        DE VERIFICAR CUALQUIER INFORMACIÓN ANTES DE CONFIAR EN ELLA. EL USO DEL
        SITIO ES BAJO SU PROPIO RIESGO. SPUR NO HACE NINGUNA REPRESENTACIÓN O
        GARANTÍA DE QUE EL USO DEL SITIO SERÁ ININTERRUMPIDO, COMPLETAMENTE
        SEGURO O LIBRE DE ERRORES. USTED ES RESPONSABLE DE TOMAR TODAS LAS
        PRECAUCIONES NECESARIAS PARA ASEGURARSE DE QUE CUALQUIER CONTENIDO QUE
        PUEDA OBTENER DEL SITIO ESTÉ LIBRE DE VIRUS, GUSANOS U OTRO “MALWARE”.
      </p>
      <h3>Marcas registradas</h3>
      <p>
        Todas las marcas registradas, marcas de servicio y logotipos que se
        utilizan o se muestran en el Sitio son propiedad de Spur. Usted debe
        obtener el permiso por escrito de Spur antes de usar cualquier marca
        comercial o marca de servicio de Spur. El uso no autorizado de cualquier
        marca comercial, marca de servicio o logotipo utilizado en el Sitio
        puede constituir una violación de las leyes de marcas comerciales
        estatales, nacionales e internacionales. Además, los íconos, gráficos,
        logotipos y scripts personalizados de Spur en el Sitio pueden estar
        cubiertos por las leyes de marcas comerciales, imagen comercial,
        derechos de autor u otros derechos de propiedad, y no pueden ser
        copiados, modificados o utilizados, en su totalidad o en parte, sin el
        permiso previo por escrito de Spur.
      </p>
      <h3>Aviso de infracción de derechos de autor</h3>
      <p>
        La política de Spur es eliminar datos o contenido que infrinja la ley de
        derechos de autor aplicable. De conformidad con la § 512 del Título 17
        del Código de los Estados Unidos, Spur ha implementado procedimientos
        para recibir notificación por escrito de la violación de derechos de
        autor reclamados y para procesar tales reclamaciones de acuerdo con la
        ley. Para presentar una notificación de infracción de derechos de autor
        con nosotros, deberá enviar una comunicación escrita al Departamento
        Legal de Spur, que se enumeran a continuación, que contenga
        sustancialmente la siguiente información o cualquier otra información
        que pueda ser requerida por 17 U.S.C. § 512(c)(3):
      </p>
      <ul>
        <li>
          una firma física o electrónica de una persona autorizada para actuar
          en nombre del propietario de un derecho exclusivo que supuestamente se
          ha infringido;
        </li>
        <li>
          identificación del trabajo protegido por derechos de autor que se
          alega ha sido infringido, o, si múltiples trabajos protegidos por
          derechos de autor en un solo sitio en línea están cubiertos por una
          sola notificación, una lista representativa de tales trabajos en ese
          sitio;
        </li>
        <li>
          identificación del material que se reclama en violación de los
          derechos o es objeto de una actividad violatoria y que debe ser
          eliminado o cuyo acceso debe ser desactivado, e información
          razonablemente suficiente para permitir al proveedor de servicios
          localizar el material;
        </li>
        <li>
          información razonablemente suficiente para permitir que el proveedor
          de servicios se ponga en contacto con la parte reclamante, como una
          dirección, un número de teléfono y, de estar disponible, una dirección
          de correo electrónico a través de la cual se pueda contactar a la
          parte reclamante;
        </li>
        <li>
          una declaración de que la parte reclamante cree de buena fe que el uso
          del material de la manera reclamada no está autorizado por el
          propietario de los derechos de autor, su agente o la ley; y
        </li>
        <li>
          una declaración de que la información de la notificación es exacta y,
          bajo pena de perjurio, que la parte reclamante está autorizada a
          actuar en nombre del propietario de un derecho exclusivo que
          supuestamente se ha infringido.
        </li>
      </ul>
      <p>
        Por favor dirija dicha notificación al Departamento Legal de Spur al
        P.O. Box 107, Huntsville, Alabama 35804 o por correo electrónico a{' '}
        <a href="mailto:legal@spurstaffing.com">legal@spurstaffing.com</a>.
      </p>
      <p>
        La información de contacto anterior es para uso exclusivo con el aviso
        de infracción de derechos de autor y usted no puede recibir una
        respuesta a ninguna otra comunicación, retroalimentación, comentario o
        solicitud de asistencia técnica entregada a la dirección o correo
        electrónico anterior.
      </p>
      <h3>Críticas, comentarios y otros contenidos</h3>
      <p>
        Si usted publica cualquier Contenido Generado por el Usuario,
        incluyendo, pero no limitado a, revisiones, comentarios, fotos,
        declaraciones, ideas o preguntas en el Sitio, usted reconoce y acepta
        que todo dicho Contenido Generado por el Usuario deberá cumplir con los
        Términos de Servicio y no podrá utilizar ninguna dirección de correo
        electrónico falsa o “ficticia” o hacerse pasar por otra persona o
        entidad, o de otra manera inducir a error con respecto al origen de
        dicho Contenido Generado por el Usuario.
      </p>
      <p>
        A menos que indiquemos lo contrario, usted otorga a Spur una licencia
        ilimitada, mundial, perpetua, irrevocable, para toda la empresa,
        transmisible, transferible y libre de regalías para usar su Contenido
        Generado por el Usuario en cualquier medio y de cualquier forma. Si
        usted proporciona cualquier nombre o nombre de usuario en relación con
        dicho Contenido Generado por el Usuario, usted otorga a Spur todo
        derecho, título e interés sobre ese nombre o nombre de usuario. Usted
        declara y garantiza que todo el Contenido Generado por el Usuario que
        envíe o publique cumple con las directrices o normas de la Comisión
        Federal de Comercio de los Estados Unidos, incluyendo, pero sin
        limitarse a, 16 C.F.R. Parte 255 con respecto a los requisitos de
        veracidad en la publicidad y divulgación. Usted declara y garantiza que
        todo el Contenido Generado por el Usuario que envía al Sitio es preciso,
        veraz y sin engaño, y que posee evidencia para respaldar cualquier y
        todas las afirmaciones hechas en dicho Contenido Generado por el
        Usuario. Además, usted declara y garantiza que es propietario o tiene la
        autoridad legal de los derechos de propiedad del Contenido Generado por
        el Usuario que envía o publica en el Sitio y que, excepto cuando lo
        prohíba la ley aplicable o cuando se acuerde lo contrario por escrito
        firmado por un funcionario de Spur y usted, usted indemnizará, defenderá
        y mantendrá indemne a Spur por todas las reclamaciones y/o demandas que
        resulten de su publicación o publicación del Contenido Generado por el
        Usuario.
      </p>
      <h3>Modificaciones</h3>
      <p>
        Spur se reserva el derecho de modificar el Sitio y las reglas y
        regulaciones que rigen su uso, en cualquier momento, incluyendo, sin
        limitación, estos Términos de Servicio. Las modificaciones se publicarán
        en el Sitio y se revisará la fecha de “Ultima actualización” que figura
        en la parte superior de esta página web. Usted entiende y acepta que si
        utiliza este Sitio después de la fecha en que los Términos de Servicio
        han cambiado, Spur tratará su uso como aceptación de los Términos de
        Servicio actualizados. Spur puede hacer cambios en los servicios
        descritos en el Sitio en cualquier momento.
      </p>
      <h3>Violación de las normas y reglamentos; Divulgación de información</h3>
      <p>
        Spur se reserva el derecho de buscar todos los remedios disponibles en
        la ley y en equidad por violaciones de las reglas y regulaciones
        establecidas en estos Términos de Servicio, incluyendo el derecho de
        bloquear el acceso desde una dirección particular de Internet al Sitio.
        Spur puede cooperar con las autoridades legales y/o terceras partes en
        la investigación de cualquier delito o injusticia civil. Con excepción
        de lo que pueda estar expresamente limitado por la Política de
        privacidad o de lo acordado por escrito y firmado por un funcionario de
        Spur y usted, Spur se reserva el derecho de hacerlo en todo momento:
      </p>
      <ul>
        <li>
          revelar cualquier información que Spur considere necesaria para
          satisfacer cualquier ley, regulación, proceso legal o solicitud
          gubernamental aplicable; o
        </li>
        <li>
          editar, negarse a publicar o eliminar cualquier información o
          material, en su totalidad o en parte, según corresponda, a la sola
          discreción de Spur.
        </li>
      </ul>
      <h3>Indemnización</h3>
      <p>
        Además y acumulativo a cualquier obligación de indemnización que se
        disponga de otra manera en este documento y excepto cuando lo prohíba la
        ley aplicable o cuando se acuerde por escrito por un funcionario de Spur
        y usted, usted acepta indemnizar, eximir de responsabilidad y defender a
        Spur y a sus funcionarios, directores, empleados, agentes, afiliados,
        sucesores y cesionarios permitidos (colectivamente denominadas, las “
        <strong>Partes indemnizadas</strong>“) contra cualquier pérdida, daño,
        responsabilidad, deficiencia, reclamo, acción, juicio, o juicio,
        acuerdos, intereses, adjudicaciones, sanciones, multas, costos o gastos
        de cualquier tipo, incluidos los honorarios de abogados, en los que
        incurra una Parte Indemnizada (colectivamente denominadas, “
        <strong>Pérdidas</strong>“), que surjan o estén relacionados con
        cualquier reclamación de terceros (incluida la reclamación de cualquier
        otro usuario) que surja del incumplimiento por su parte de cualquier
        garantía, representación o acuerdo contenido en estos Términos de
        Servicio por parte de usted o de sus funcionarios, directores,
        empleados, agentes, afiliados, sucesores o cesionarios autorizados. Sin
        perjuicio de lo dispuesto en estos Términos de Servicio, una Parte
        Indemnizada puede seleccionar a su propio asesor legal para que
        represente sus intereses.
      </p>
      <h3>Limitación de responsabilidad</h3>
      <p>
        USTED ENTIENDE Y ACEPTA QUE SPUR NO SERÁ RESPONSABLE DE NINGÚN DAÑO
        DIRECTO, INDIRECTO, INCIDENTAL, CONSECUENTE O ESPECIAL, YA SEA BASADO EN
        CONTRATO, AGRAVIO, RESPONSABILIDAD ESTRICTA O DE OTRO TIPO, QUE SURJA DE
        O DE ALGUNA MANERA ESTÉ RELACIONADO CON EL ACCESO O USO DEL SITIO O EL
        DESEMPEÑO O CONDUCTA DEL TRABAJADOR O LUGAR DE TRABAJO DURANTE UN
        TRABAJO, INCLUSO SI HEMOS SIDO ADVERTIDOS DE LA POSIBILIDAD DE TALES
        DAÑOS, INCLUYENDO PERO NO LIMITADO A: (A) CUALQUIER ACCIÓN TOMADA EN
        CONEXIÓN CON UNA INVESTIGACIÓN POR LAS AUTORIDADES DE APLICACIÓN DE LA
        LEY CON RESPECTO AL USO DEL SITIO POR USTED O CUALQUIER OTRA PARTE; (B)
        CUALQUIER ACCIÓN TOMADA EN CONEXIÓN CON LOS DERECHOS DE AUTOR U OTROS
        PROPIETARIOS DE PROPIEDAD INTELECTUAL; (C) CUALQUIER DAÑO A LA
        COMPUTADORA DE CUALQUIER USUARIO, DISPOSITIVO MÓVIL, U OTRO EQUIPO O
        TECNOLOGÍA; (D) CONFIANZA DE CUALQUIER PARTE EN CUALQUIER CONTENIDO
        OBTENIDO A TRAVÉS DEL USO DE ESTE SITIO; (E) LA INCAPACIDAD DE CUALQUIER
        TRABAJADOR PARA REALIZAR CUALQUIER TRABAJO A SATISFACCIÓN DEL LUGAR DE
        TRABAJO; (F) LA INCAPACIDAD DE CUALQUIER LUGAR DE TRABAJO PARA PAGAR
        CUALQUIER CANTIDAD ACORDADA; O (G) YA SEA CAUSADA EN SU TOTALIDAD O EN
        PARTE POR NEGLIGENCIA, ACTOS FORTUITOS, FALLAS EN LAS
        TELECOMUNICACIONES, ROBO O DESTRUCCIÓN DE, O ACCESO NO AUTORIZADO AL
        SITIO, O INFORMACIÓN O PROGRAMAS RELACIONADOS, QUE SURJAN EN RELACIÓN
        CON: (1) ERRORES U OMISIONES EN, O RETRASOS EN LA TRANSMISIÓN DE
        INFORMACIÓN HACIA O DESDE EL USUARIO; (2) INTERRUPCIONES EN LAS
        CONEXIONES DE TELECOMUNICACIONES AL SITIO; O (3) VIRUS.
      </p>
      <p>
        NUESTRA RESPONSABILIDAD TOTAL ANTE USTED POR TODAS LAS CAUSAS DE ACCIÓN
        Y BAJO TODAS LAS TEORÍAS ESTARÁ LIMITADA A LA CANTIDAD QUE USTED HAYA
        PAGADO POR EL USO DEL SITIO, SI LA HUBIERA, Y SI USTED NO HA PAGADO
        NINGUNA CANTIDAD, ENTONCES $50. USTED TAMBIÉN RECONOCE Y ACEPTA QUE HA
        VISTO O UTILIZADO EL SITIO CON PLENO CONOCIMIENTO DE LA LIMITACIÓN DE
        NUESTRA RESPONSABILIDAD EN ESTOS TÉRMINOS DE SERVICIO. AL ACCEDER AL
        SITIO, USTED ENTIENDE QUE PUEDE ESTAR RENUNCIANDO A SUS DERECHOS CON
        RESPECTO A RECLAMOS QUE EN ESTE MOMENTO SON DESCONOCIDOS O
        INSOSPECHADOS, Y DE ACUERDO CON DICHA RENUNCIA, USTED RECONOCE QUE HA
        LEÍDO Y ENTENDIDO, Y POR LA PRESENTE RENUNCIA EXPRESA A LOS BENEFICIOS
        DE LA SECCIÓN 1542 DEL CÓDIGO CIVIL DE CALIFORNIA, Y DE CUALQUIER LEY
        SIMILAR DE CUALQUIER ESTADO O TERRITORIO, QUE ESTABLECE LO SIGUIENTE:
        “UNA EXONERACIÓN GENERAL NO SE EXTIENDE A LAS RECLAMACIONES QUE EL
        ACREEDOR NO SABE O SOSPECHA QUE EXISTEN A SU FAVOR EN EL MOMENTO DE LA
        EJECUCIÓN DE LA EXONERACIÓN, LAS CUALES, DE SER CONOCIDAS POR ÉL, DEBEN
        HABER AFECTADO MATERIALMENTE SU ACUERDO CON EL DEUDOR.”
      </p>
      <p>
        Cuando la ley aplicable no permite exclusiones de responsabilidad por
        ciertos tipos de daños o cuando se acuerde lo contrario por escrito por
        un oficial de Spur y usted, es posible que algunas de las limitaciones
        anteriores no se apliquen a usted. En tales casos, la responsabilidad de
        Spur se limitará al máximo permitido por la ley aplicable y cualquier
        acuerdo escrito de este tipo.
      </p>
      <h3>Sitios de terceros</h3>
      <p>
        Algunos enlaces en el Sitio o Sitio pueden alejarlo del Sitio y/o Sitio
        de Spur o redirigirlo a otros sitios web, incluyendo sitios web operados
        por terceros. Tenga en cuenta que esos sitios web pueden recopilar
        información de identificación personal (“IIP”) de usted o acerca de
        usted y no IIP acerca de su visita. Los sitios enlazados no están bajo
        el control de Spur, y el contenido disponible en los sitios de Internet
        enlazados a este sitio no refleja necesariamente la opinión de Spur.
        Spur proporciona estos enlaces a otros sitios de Internet para su
        conveniencia, y el acceso a cualquier otro sitio de Internet vinculado a
        este Sitio es bajo su propio riesgo. La inclusión de cualquier enlace no
        implica una recomendación o aprobación por parte de Spur del sitio
        enlazado. Usted debe revisar los términos de uso y las políticas de
        privacidad que se publican en cualquier sitio web que visite, antes de
        utilizar cualquier sitio web vinculado. Spur no acepta ninguna
        responsabilidad por cualquier información, productos, anuncios,
        contenido, servicios o software accesible a través de estos sitios web
        de terceros o por cualquier acción que usted pueda tomar como resultado
        de un enlace a cualquiera de dichos sitios web. Spur no tiene ninguna
        obligación de mantener ningún enlace en el Sitio y puede eliminar un
        enlace en cualquier momento a su entera discreción por cualquier razón.
        Spur no será responsable, directa o indirectamente, por cualquier daño o
        pérdida causada o supuestamente causada por o en conexión con el uso o
        confianza en dicho contenido, productos, servicios u otros materiales
        disponibles en o a través de dicho sitio web. Spur no es responsable de
        las prácticas de privacidad de ningún otro sitio web.
      </p>
      <h3>No existe relación fiduciaria</h3>
      <p>
        Excepto en la medida establecida por escrito y firmada por un oficial de
        Spur y usted, no existe una relación fiduciaria entre usted y nosotros.
        Los Términos no crean ninguna relación de principal y agente, sociedad,
        empresa conjunta, o en el caso de un empleador-empleado en el Lugar de
        Trabajo, entre usted y nosotros. Usted no puede celebrar ningún contrato
        en nuestro nombre ni vincularnos de ninguna manera.
      </p>
      <h3>Derecho a monitorear</h3>
      <p>
        Spur se reserva el derecho de monitorear activamente el uso del Sitio y
        del Sitio y usar cualquier información recopilada durante dicho
        monitoreo para cualquier propósito permitido por la Política de
        privacidad. Además, Spur puede, en cualquier momento que lo considere
        apropiado, remover cualquier material del Sitio que, a la sola
        discreción de Spur, pueda ser ilegal, pueda someter a Spur a
        responsabilidad, pueda violar estos Términos de Servicio, o sea, a la
        sola discreción de Spur, inconsistente con el propósito de Spur para el
        Sitio.
      </p>
      <h3>Comunicaciones electrónicas</h3>
      <p>
        Cuando usted visita el Sitio o el Sitio o nos envía un correo
        electrónico, se está comunicando con nosotros electrónicamente. Usted
        consiente en recibir comunicaciones de nosotros electrónicamente. Nos
        comunicaremos con usted por correo electrónico, enviándole mensajes a
        través del Sitio, o publicando avisos en el Sitio. Usted acepta que
        todos los acuerdos, notificaciones, divulgaciones y otras comunicaciones
        que le proporcionamos electrónicamente satisfacen cualquier requisito
        legal de que dichas comunicaciones sean por escrito. Además, usted
        acepta que cualquier notificación proporcionada por nosotros
        electrónicamente se considerará entregada y recibida en la fecha en que
        transmitamos dicha comunicación electrónica según se describe en estos
        Términos de Servicio.
      </p>
      <h3>Ley aplicable y principios generales</h3>
      <p>
        Este Sitio es operado por Spur desde sus oficinas en los Estados Unidos
        de América (“EE.UU.”). Spur no garantiza que la información del Sitio o
        del Sitio sea apropiada o esté disponible para su uso en otros lugares
        fuera de los Estados Unidos, y se prohíbe el acceso al Sitio desde
        territorios donde el contenido del Sitio pueda ser ilegal. Aquellos que
        decidan acceder a este Sitio o al Sitio desde otros lugares fuera de los
        Estados Unidos lo hacen por su propia iniciativa y son responsables del
        cumplimiento de las leyes locales aplicables.
      </p>
      <p>
        Al usar el Sitio, sin importar dónde viva o se encuentre en el mundo,
        usted acepta estos Términos de Servicio y cualquier reclamo relacionado
        con la información, servicios o productos disponibles a través de este
        Sitio o, en el caso de un Trabajador, su empleo por nosotros, se regirá
        por las leyes del Estado de Alabama, EE.UU., excluyendo la aplicación de
        sus reglas de conflictos de leyes.
      </p>
      <p>
        Si alguna disposición de estos Términos de Servicio se considera ilegal,
        nula o por cualquier razón inaplicable, entonces esa disposición se
        considerará separable de estos Términos de Servicio y no afectará la
        validez y aplicabilidad de las disposiciones restantes.
      </p>
      <p>
        Usted no puede ceder, transferir o delegar estos Términos de Servicio y
        sus derechos y obligaciones en virtud del presente documento sin el
        consentimiento previo por escrito de Spur. Spur puede, sin restricción,
        asignar, transferir o delegar estos Términos de Servicio y cualquier
        derecho u obligación, a su sola discreción, con 30 días de anticipación.
        Su derecho a cancelar estos Términos de Servicio en cualquier momento no
        se verá afectado.
      </p>
      <p>
        El hecho de que Spur no cumpla con el estricto cumplimiento de alguna de
        las disposiciones de estos Términos de Servicio no constituirá una
        renuncia al derecho de Spur de hacer cumplir posteriormente dicha
        disposición o cualquier otra disposición de estos Términos de Servicio.
      </p>
      <p>
        Usted acepta que cualquier reclamo que pueda tener como resultado de o
        relacionado con su uso del Sitio, o su relación con Spur, debe ser
        presentado dentro de un año después de que dicho reclamo haya surgido;
        de lo contrario, su reclamo queda permanentemente excluido. Usted acepta
        que cualquier violación, o amenaza de violación, por su parte de estos
        Términos de Servicio constituye una práctica comercial ilegal e injusta
        que nos causará un daño irreparable e incuantificable. También acepta
        que los daños monetarios serían inadecuados para dicho daño y consiente
        en que obtengamos cualquier medida cautelar o equitativa que
        consideremos necesaria o apropiada. Estos recursos son adicionales a
        cualquier otro recurso que podamos tener ante la ley o en equidad.
      </p>
      <p>
        Cualquier notificación u otra comunicación a los Trabajadores y/o
        Lugares de Trabajo permitidos o requeridos bajo estos Términos de
        Servicio será por escrito y dada por Spur a través de las notificaciones
        del Sitio, excepto en la medida en que otro método sea requerido por la
        ley o acordado por escrito y firmado por un oficial de Spur y usted.
      </p>
      <p>
        Excepto en la medida en que puedan ser complementados por términos y
        condiciones, políticas, directrices o estándares adicionales, estos
        Términos de Servicio constituyen el acuerdo completo entre Spur y usted
        en relación con el tema del presente, y reemplazan cualquier y todos los
        acuerdos o entendimientos orales o escritos previos entre Spur y usted
        en relación con el acceso y uso del Sitio (excepto en la medida en que
        un acuerdo escrito por separado disponga lo contrario y esté firmado por
        un funcionario de Spur y por usted, y específicamente disponga que
        reemplaza cualquier término en conflicto en estos Términos de Servicio).
      </p>
      <h3>Arbitraje y acción colectiva</h3>
      <p>
        Cualquier disputa, controversia o reclamación que surja de, relacionada
        con, o en conexión con, su uso del Sitio, el contenido del Sitio, estos
        Términos de Servicio, o en el caso de un Trabajador que haya sido
        contratado por nosotros, incluyendo la violación, terminación o validez
        de este, será resuelta finalmente mediante arbitraje vinculante ante la
        Asociación Americana de Arbitraje utilizando sus Reglas de Arbitraje
        Comercial (excepto donde lo prohíba la ley). El lugar de dicho arbitraje
        será Huntsville, Alabama. El mediador estará facultado para decidir
        sobre cualquier impugnación de su propia jurisdicción o de la validez o
        aplicabilidad de cualquier parte del acuerdo de arbitraje. En la medida
        máxima permitida por la ley, usted acepta arbitrar únicamente en forma
        individual, y reconoce y acepta que estos Términos de Servicio no
        permiten el arbitraje de clase ni ninguna reclamación presentada como
        demandante o miembro de la clase en ningún procedimiento de arbitraje
        colectivo, representativo o de clase. En la máxima medida permitida por
        la ley, usted acepta que el tribunal arbitral no puede consolidar más de
        las reclamaciones de una persona, y que no puede presidir de ninguna
        otra manera ninguna forma de un procedimiento de representación o de
        clase. Usted acepta que, a pesar de la facultad del tribunal para
        decidir sobre su propia jurisdicción y la validez o aplicabilidad del
        acuerdo de arbitraje, el tribunal no tiene facultad para decidir sobre
        la validez o aplicabilidad del acuerdo de arbitraje únicamente sobre una
        base individual. Usted acepta que en el caso de que la prohibición del
        arbitraje de clase sea considerada inválida o inaplicable por un
        tribunal de jurisdicción competente, entonces las partes restantes de
        este acuerdo de arbitraje permanecerán en pleno vigor y efecto.
        Cualquier tribunal con jurisdicción competente puede dictar sentencia
        sobre cualquier laudo, y usted específicamente acepta y renuncia a la
        objeción y por la presente se somete a la jurisdicción de los tribunales
        estatales y federales del Condado de Madison, Alabama. Sin perjuicio de
        las disposiciones de este párrafo, usted acepta que podemos solicitar
        una medida cautelar temporal o preliminar contra usted antes de arbitrar
        cualquier disputa, controversia o reclamación que sea necesaria para
        proteger nuestros intereses en la aplicación de estos Términos de
        Servicio sin renunciar a las disposiciones de arbitraje de estos
        Términos de Servicio.
      </p>
      <h3>RENUNCIA AL JUICIO POR JURADO</h3>
      <p>
        POR SEPARADO Y APARTE DE LA DISPOSICIÓN DE ARBITRAJE ANTERIOR, Y ADEMÁS
        DE DICHA DISPOSICIÓN, USTED RENUNCIA IRREVOCABLE E INCONDICIONALMENTE,
        EN LA MAYOR MEDIDA PERMITIDA POR LA LEY APLICABLE, A CUALQUIER DERECHO
        QUE TENGA A UN JUICIO POR JURADO EN CUALQUIER ACCIÓN LEGAL,
        PROCEDIMIENTO, CAUSA DE ACCIÓN O RECONVENCIÓN QUE SURJA DE O EN RELACIÓN
        CON ESTOS TÉRMINOS DE SERVICIO, LAS TRANSACCIONES CONTEMPLADAS EN EL
        PRESENTE DOCUMENTO O, EN EL CASO DE UN TRABAJADOR, SU EMPLEO POR SPUR.
        USTED CERTIFICA Y RECONOCE QUE HA CONSIDERADO LAS IMPLICACIONES DE ESTA
        RENUNCIA, QUE HA HECHO ESTA RENUNCIA A SABIENDAS Y VOLUNTARIAMENTE, Y
        QUE FUIMOS INDUCIDOS A ENTRAR EN ESTOS TÉRMINOS DE SERVICIO POR, ENTRE
        OTRAS COSAS, LA RENUNCIA Y CERTIFICACIONES EN ESTE PÁRRAFO.
      </p>
      <h3>Jurisdicción y kugar de celebración</h3>
      <p>
        SEPARADO Y APARTADO DE LA PREVIA DISPOSICIÓN DE ARBITRAJE, Y ADEMÁS DE
        TAL DISPOSICIÓN, usted acepta que cualquier demanda legal, acción o
        procedimiento que surja de o en relación con estos Términos de Servicio,
        las transacciones contempladas en este documento, o en el caso de un
        Trabajador, su empleo por Spur, que por cualquier razón no se someta a
        arbitraje (o en el caso de que la disposición de arbitraje se elimine de
        este acuerdo) sólo se instituirá en los tribunales estatales o federales
        ubicados en el Condado de Madison, Alabama, y usted se somete
        irrevocablemente a la jurisdicción exclusiva de dichos tribunales en
        cualquier demanda, acción o procedimiento que no esté cubierto por la
        disposición de arbitraje establecida anteriormente. Las disposiciones de
        este párrafo no alteran, enmiendan ni sustituyen el requisito de que
        usted someta cualquier disputa, controversia o reclamo que surja de o
        esté relacionado con estos Términos de Servicio, las transacciones
        contempladas en el presente, o en el caso de un Trabajador a quien usted
        haya contratado por medio de Spur, a un arbitraje obligatorio como se
        explicó anteriormente.
      </p>
    </LegalDocument>
  );
}

export default TermsEs;
